module.exports = __webpack_public_path__ + "media/pages/assets/images/gallery/2021/march-4063f4fb0ec72b7a0d28c5ebed6fd104.png";